import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { AgendaComponent } from './components/agenda/agenda.component';
import { ErrorComponent } from './components/error.component';
import { ConfirmationComponent } from './components/confirmation.component';
import { ReportsComponent } from './components/reports.component';
import { ReportscmComponent } from './components/reportscm.component';
import { AgendaProComponent } from './components/agendapro.component';
import { FeedbackProComponent } from './components/feedback.component';
import { GarantiaComponent } from './components/garantia.component';
import { ReportAgendaProComponent } from './components/reportAgendaPro.component';
import { EncuestaComponent } from './components/encuesta.component';
import { ReportEncuestaComponent } from './components/reportEncuesta.component';
import { LandingComponent } from './components/landing.component';
import { AgendaCoComponent } from './components/agenda-co/agenda-co.component';

const appRoutes: Routes = [
    { path: 'ags', component: AgendaComponent },
    { path: 'agsCo/:clienteAcronym', component: AgendaCoComponent },
    //{ path: 'ag/:clienteName', component: AgendaComponent },
    { path: 'agsCo', component: AgendaCoComponent },
    { path: 'ag/:clienteAcronym', component: AgendaComponent },
    { path: 'ag', component: AgendaComponent },
    { path: 'confirmation', component: ConfirmationComponent },
    { path: 'confirmation/:cantidad/:horario/:fecha/:ticket/:archivo/:clienteId', component: ConfirmationComponent },
    //{ path: 'reports', component: ReportsComponent },
    { path: 'reportscm', component: ReportscmComponent },
    { path: 'agenda-pro', component: AgendaProComponent },
    { path: 'feedback', component: FeedbackProComponent },
    { path: 'garantia', component: GarantiaComponent },
    { path: 'report-huawei', component: ReportAgendaProComponent },
    { path: 'report-encuesta', component: ReportEncuestaComponent },
    { path: 'encuesta', component: EncuestaComponent },
    { path: 'aghuawei', component: LandingComponent },
    { path: '**', component: ErrorComponent }

];
export const appRoutingProviders: any[] = [];
export const routing: ModuleWithProviders<any> = RouterModule.forRoot(appRoutes);